export const platforms = [
  {
    name: "AutoGuard",
    logo: "/logos/autoguard.png",
  },
  {
    name: "MiCash",
    logo: "/logos/micash.png",
  },
  {
    name: "Life Happens",
    logo: "/logos/lifehappens.png",
  },
  {
    name: "Get Me Printing",
    logo: "/logos/getmeprinting.png",
  },
  {
    name: "PicMe",
    logo: "/logos/picme.png",
  },
  {
    name: "Evidence Web",
    logo: "/logos/evidenceweb.png",
  },
  {
    name: "FPI",
    logo: "/logos/fpi.png",
  },
  {
    name: "BOS",
    logo: "/logos/bos.png",
  },
  {
    name: "Leo Membership",
    logo: "/logos/leomembership.png",
  },
];

export type Platform = (typeof platforms)[number];

// Convenience lookup: platformLogoMap["AutoGuard"] → "/logos/autoguard.png"
export const platformLogoMap: Record<string, string> = Object.fromEntries(
  platforms.map((p) => [p.name, p.logo])
);
